
    import countTo from 'vue-count-to';

    export default {
        components: { 
            countTo,
        },
        data() {
            return {
                counterUpContent: [
                    { 
                        endVal: 1283,
                        title: "Chargers <br> Installed"
                    },
                    {
                        endVal: 117,
                        title: "EV Charger <br> Products"
                    },
                    {
                        endVal: 6,
                        title: "Versatile <br> Services"
                    },
                ]
            }
        },
    };
